<template>
  <section class="news">
    <title-bg></title-bg>
    <a-spin :spinning="loading" tip="Loading..." :delay="10" style="min-height: 70px;">
    <ul class="news-list" v-if="Object.keys(newList).length > 0">
      <li class="news-list-item" v-for="(item, index) in newList" :key="index" @click="bindNewsItem(item.id)">
        <span class="news-list-item-title">{{item.title}}</span>
        <span class="news-list-item-date">{{item.create_time ? item.create_time.substring(0,10) : ''}}</span>
      </li>
    </ul>
    <a-empty v-else description="暂无数据" style="margin-top:20px;"/>
    </a-spin>
    <pagination :currentPage="currentPage" :total="total" :pageType="'schoolnews'" :limitPage="limitPage"></pagination>
  </section>
</template>
<script>
import TitleBg from '../../../components/TitileBg'
import Pagination from '../../../components/Pagination'
import { SchoolNews } from '../../../common/cultural/SchoolNews'
export default {
  mixins: [SchoolNews],
  components: {
    Pagination,
    TitleBg,
  },
}
</script>
<style lang="less" scoped>
.news{
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
  &-list{
    display: flex;
    flex-direction: column;
    margin: 43px 0 50px;
    width: 100%;
    &-item{
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 43px;
      border-top: 1px solid #D1D1D1;
      &:last-child{
        border-bottom: 1px solid #D1D1D1;
      }
      &-title{
        font-size:15px;
        font-weight:400;
        color:rgba(0,0,0,1);
        cursor: pointer;
        &:hover{
          color: #004d9a;
        }
        &:active, &:visited{
          color: #666;
        }
      }
      &-date{
        font-size:13px;
        font-weight:400;
        color:rgba(153,153,153,1);
      }
    }
  }
  &-pagination{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 50px;
  }
}
.pagination{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 68px;
  & /deep/ .ant-pagination-item{
    & > a{
      color: #333;
    }
    &:focus, &:hover{
      border-color: #C16613;
    }
    &-active{
      background: #C16613;
      border-color: #C16613;
      & > a{
        color: #fff;
      }
    }
  }
}
</style>
